export const LOADER_STATUS = 'boilderplate/Gstr1New/Fetch&Reconcile/LOADER_STATUS';
export const FETCH_RECO_DATA = 'boilderplate/Gstr1New/Fetch&Reconcile/FETCH_RECO_DATA';
export const EINV_SUMMARY_DATA = 'boilderplate/Gstr1New/Fetch&Reconcile/EINV_SUMMARY_DATA';
export const RECO_SUMMARY_DATA = 'boilderplate/Gstr1New/Fetch&Reconcile/RECO_SUMMARY_DATA';
export const RECO_LINE_SUMMARY_DATA = 'boilderplate/Gstr1New/Fetch&Reconcile/RECO_LINE_SUMMARY_DATA';
export const UPLOAD_HISTORY_DATA = 'boilderplate/Gstr1New/Fetch&Reconcile/UPLOAD_HISTORY_DATA';
export const FETCH_FILTER_RETURN_PERIOD = 'boilerplate/Gstr1New/Fetch&Reconcile/FETCH_FILTER_RETURN_PERIOD';

export const dataTypes = [
    {
    label: "All",
    // value: '"B2B","CDN","CDNUR","EXP"',
    value:'All',
    tagClassName: "special",
    checked: true,
    children: [
      {
        label: "B2B",
        value: "B2B",
      },
      {
        label: "CDN",
        value: "CDNR",
      },
      {
        label: "CDNUR",
        value: "CDNUR",
      },
      {
        label: "EXP",
        value: "EXP",
      },
    ]
    }
];
export const categories = [
    {
    label: "All",
    value: "All",
    tagClassName: "special",
    checked: true,
    children: [
      {
        label: "Matched",
        value: "Matched",
      },
      {
        label: "Mismatch",
        value: "Mismatch",
      },
      {
        label: "Missing in GTP",
        value: "Missing in GTP",
      },
      {
        label: "Missing in GSTN",
        value: "Missing in GSTN",
      },
    ]
    }
];